<div class="form-parent">
       <kgrid [apiName]="apiName"
       [label]="label"
       [areaName]="areaName"
       [name]="apiName"
       reportName="GoodsUnit"
       [inputEditorform]="inputEditorform"
       [IgnoreDeletePermission]= "IgnoreDelete"
       [deleteMessage]="deleteMessage">
</kgrid>

</div>

